import React, { FC, useState } from 'react'
import Image from 'next/image'
import {
  ImageButton,
  LightBox,
} from 'src/uikit'
import {
  Box,
  Container,
  Grid,
  GridItem,
  Stack,
} from '@chakra-ui/react'
import Carousel from '../common/Carousel'
import Main from './Main'

interface Props {
  images: Array<ImageGlobal.Image>
  badge?: string
  showMore: string
  maxItems?: number
}

const OfferGallery: FC<Props> = ({ images, showMore, badge, maxItems = 3 }) => {
  const [open, setOpen] = useState(true)
  const [slide, setSlide] = useState(1)

  const onImageClick = (open, slide) => {
    setOpen(open)
    setSlide(slide)
  }

  const maxItemsSliced = maxItems - 1

  return <>
    <Box bgColor="baseWhite" mx="-1rem" mt="2" mb="5" p="5px" borderRadius="10px" display={{ base: 'block', md: 'none' }}>
      <Carousel
        slidesPerView={1}
        withNavigation
        withScrollbar
        spaceBetween={30}
        className="offer-gallery-carousel"
      >
        {images.map((image, idx) => {
          return (
            <Carousel.Item key={`${image.src}${image.alt}`}>
              <Box w="100%" h="16rem">
                <Image src={image.src} alt={image.alt} loading={idx === 0 ? undefined : 'lazy'} layout="fill" objectFit="contain" />
              </Box>
            </Carousel.Item>
          )
        })}
      </Carousel>
    </Box>
    <Container as={Stack} maxW="6xl" minHeight="40rem" display={{ base: 'none', md: 'block' }}>
      <Grid templateColumns="3fr 1fr" gap="xs">
        <GridItem onClick={() => onImageClick(!open, 1)}>
          <Main src={images[0].src} alt={images[0].alt} badge={badge} />
        </GridItem>
        {images && (
          <GridItem>
            {images.slice(1).map((image, index) => {
              if (index > maxItemsSliced) return
              return (
                <ImageButton
                  key={`${image.src}-${image.alt}`}
                  src={image.src}
                  alt={image.alt}
                  onClick={() => onImageClick(!open, index + 2)}
                  marginBottom={index < maxItemsSliced ? 'xs' : ''}
                  action={index === maxItemsSliced ? showMore : undefined}
                />
              )
            })}
            <LightBox status={open} images={images} slide={slide} />
          </GridItem>
        )}
      </Grid>
    </Container>
  </>
}

export default OfferGallery
